module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_06 (1).9a18ff52.png";